<template>
  <div class="home-container">
    <el-container style="display: block">
      <MyHeader></MyHeader>
      <el-main>
			<!-- <span class="free">（付费小圈可生成优惠券）</span> -->
        <div class="main-title">我创建的小圈</div>
        <div class="main-box">
          <el-card class="box-card" @click.native="clickCard(item)" v-for="item in cardList" :key="item.id" :class="item.isVip == true ? 'masks' : ''">
            <img class="box-img" :src="'https://quanmai.qianniucaixin.com'+item.groupimg" />
            <div class="box-name">{{ item.groupname }}</div>
            <!-- <div class="box-time">创建{{ item.time }}天</div> -->
          </el-card>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import MyHeader from './home/navigation/Header.vue'
export default {
  name: 'HomeView',
  // 注册组件
  components: {
    MyHeader,
  },
  data() {
    return {
      cardList: [],
    }
  },
  mounted() {
  	this.getData()
  },
  methods: {
    clickCard(groupitem) {
      localStorage.setItem('groupitem', JSON.stringify(groupitem));
      this.$router.push('/over/singleless');
    },
	 getData(){
		 const user = JSON.parse(localStorage.getItem('user'));
		 let url = `https://quanmai.qianniucaixin.com/groupxiaoquan/app_findmygroup_manage.php?mid=${user.mid}`;
		 this.axios.get(url).then((res) => {
			 this.cardList = res.data;
		 }) 
	 },
    // clickbtn() {},
  },
}
</script>

<style lang="scss" scoped>
.home-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  .el-main {
    color: #333;
    padding: 70px 100px 0 100px;
    .main-title {
      margin: 0 20px;
      font-size: 18px;
		font-weight: bold;
      .free {
        color: rgb(245, 127, 89);
      }
    }
    .main-box {
      display: flex;
      flex-wrap: wrap;
      .box-card {
        margin: 20px;
        padding: 20px 36px;
        text-align: center;
        .box-img {
          width: 120px;
			 height: 120px;
          border-radius: 20px;
        }
        .box-name {
          padding: 20px 0;
          font-size: 18px;
          font-weight: bold;
        }
        .box-time {
          color: #999;
          font-size: 14px;
        }
        &.masks {
          background: url(../assets/VIP.png) no-repeat;
          background-size: 20% auto;
          background-position: 100% 0%;
        }
      }
    }
  }
}
</style>
